import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const RevealLines = ({ lines, className = "", lineClassName = "", delay = 0, as = "div" }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden py-[0.5%]">
        <motion.div
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * 0.13, ease: EASE }}
          className={lineClassName}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 48 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export { EASE };
